<div class="badges">
  <py-badge *ngIf="product?.overlayNew && !article" type="new" [tag]="true" large="true">
    {{ 'product.new_badge' | cxTranslate }}
  </py-badge>
  <py-badge *ngIf="article?.overlayNew" type="new" [tag]="true" large="true">
    {{ 'article.new_badge' | cxTranslate }}
  </py-badge>
  <ng-container *pyPrincipalConfiguration="'enableDisplayOutgoingArea'">
    <py-badge
      *ngIf="
        product?.outgoing?.hasOutgoingOnSaleArticles &&
        ((enableProductOutletBadgeOnlyIfAllArticlesAreOutlet$ | async) ? !product?.outgoing?.hasNonOutgoingArticles : true) &&
        !article
      "
      type="outlet"
      [tag]="true"
      large="true"
    >
      {{ 'product.outlet_badge' | cxTranslate }}
    </py-badge>
    <py-badge *ngIf="article?.outgoingOnSale" type="outlet" [tag]="true" large="true">
      {{ 'article.outlet_badge' | cxTranslate }}
    </py-badge>
  </ng-container>
  <py-badge *ngIf="product?.priceCampaign && !article" type="campaign" [tag]="true" large="true">
    {{ 'product.campaign_badge' | cxTranslate }}
  </py-badge>
  <py-badge *ngIf="article?.priceCampaign" type="campaign" [tag]="true" large="true">
    {{ 'article.campaign_badge' | cxTranslate }}
  </py-badge>
  <ng-container *pyPrincipalConfiguration="'displaybadgeforZTarticle'">
    <py-badge *ngIf="product?.outgoing?.hasLastChanceArticles && !article" type="last-chance" [tag]="true" large="true">
      {{ 'product.lastChance_badge' | cxTranslate }}
    </py-badge>
    <py-badge *ngIf="article?.articleStatus === 'ZT'" type="last-chance" [tag]="true" large="true">
      {{ 'article.lastChance_badge' | cxTranslate }}
    </py-badge>
  </ng-container>
</div>

<ngb-carousel
  class="w-100"
  #carousel
  [interval]="0"
  [showNavigationArrows]="false"
  [showNavigationIndicators]="false"
  (slid)="isSliding = false"
  (slide)="isSliding = true"
  [activeId]="activeSlideId.toString()"
>
  <ng-template ngbSlide *ngFor="let image of images; let i = index" [id]="i.toString()">
    <div class="main-image" (click)="onMainImageClick(i)">
      <img [class.no-visual-search]="isEdgeBrowser" [pyMedia]="image" [draggable]="false" [alt]="alternativeText" />
    </div>
  </ng-template>
</ngb-carousel>

<div class="d-none d-md-flex justify-content-left row no-gutters mt-4 hide-on-print">
  <div
    class="gallery-image"
    class="gallery-image m-0 p-0 mb-2 mr-2"
    *ngFor="let image of images; let i = index"
    [class.gallery-image--active]="i === activeSlideId"
    (click)="navigateToSlide(i)"
  >
    <img [pyMedia]="image" [alt]="alternativeText" />
  </div>
  <span
    class="gallery-image gallery-image--placeholder m-0 p-0 mb-2"
    *ngFor="let thumb of [].constructor(thumbsPerRow - (images?.length % thumbsPerRow))"
  ></span>
  <!--  these spans are only to fill thumbnail placeholders to complete each row to 5 (thumbsPerRow) to align thumbnails better no matter how many of them are assigned to the product -->
</div>

<div class="show-only-on-print mb-2" *ngIf="images?.length && !!images[activeSlideId]">
  <img [pyMedia]="images[activeSlideId]" [draggable]="false" [alt]="alternativeText" />
</div>

<div class="d-flex d-md-none justify-content-center row p-0 m-0 mt-2">
  <div
    class="gallery-indicator mr-2 mb-2"
    (click)="navigateToSlide(i)"
    *ngFor="let image of images; let i = index"
    [class.gallery-indicator--active]="i === activeSlideId"
  ></div>
</div>
